export default __webpack_public_path__ + "static/media/FastFood_01.09ca7025.png";